import React from 'react';
import Modal from './ui/Modal.jsx';

const BillingPortalModal = ({ onClose, onOpenPortal, onOpenPlans, onBuyPack, onRequireLogin, hasUser }) => {
    return (
        <Modal title="Manage Billing" onClose={onClose} size="md">
            <div className="grid gap-3">
                <button onClick={onOpenPlans} className="w-full rounded-xl px-4 py-3 text-white bg-gradient-to-r from-teal-600 to-emerald-600">Change plan</button>
                <button onClick={onOpenPortal} className="w-full rounded-xl px-4 py-3 text-slate-200 bg-slate-800/70 ring-1 ring-white/10">Open billing portal</button>
            </div>
            <div className="mt-5">
                <div className="text-sm text-slate-400">Buy one-time credits</div>
                <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
                    <button onClick={() => { if (!hasUser && typeof onRequireLogin === 'function') { onRequireLogin(); return; } onBuyPack && onBuyPack('clinical_credits_50'); }} className="rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-left">
                        <div className="text-sm font-semibold text-teal-300">50</div>
                        <div className="text-xs text-slate-400">$1.99</div>
                    </button>
                    <button onClick={() => { if (!hasUser && typeof onRequireLogin === 'function') { onRequireLogin(); return; } onBuyPack && onBuyPack('clinical_credits_200'); }} className="rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-left">
                        <div className="text-sm font-semibold text-emerald-300">200</div>
                        <div className="text-xs text-slate-400">$5.99</div>
                    </button>
                    <button onClick={() => { if (!hasUser && typeof onRequireLogin === 'function') { onRequireLogin(); return; } onBuyPack && onBuyPack('clinical_credits_500'); }} className="rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-left">
                        <div className="text-sm font-semibold text-sky-300">500</div>
                        <div className="text-xs text-slate-400">$12.99</div>
                    </button>
                </div>
                <div className="mt-2 text-[11px] text-slate-400">* 1 credit = 1 flashcard generation</div>
            </div>
        </Modal>
    );
};

export default BillingPortalModal;
